import Vue from 'vue'
import '@babel/polyfill'
import 'mutationobserver-shim'
import './plugins/bootstrap-vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import Vuelidate from 'vuelidate'
import SweetModal from 'sweet-modal-vue/src/plugin.js'
import PriceFilter from './filters/price'
import FrontUser from './layouts/FrontUser.vue'
import BackAdmin from './layouts/BackAdmin.vue'
import BackClient from './layouts/BackClient.vue'
import BackCleaner from './layouts/BackCleaner.vue'
import BackSupport from './layouts/BackSupport.vue'
import FrontHero from './layouts/FrontHero.vue'
import FrontExperience from './layouts/FrontExperience.vue'
import axios from 'axios'
import VueFeather from 'vue-feather'
import VueCookies from 'vue-cookies'
import VueEllipseProgress from 'vue-ellipse-progress'
import VueI18n from 'vue-i18n'
import messages from './lang'
import Multiselect from 'vue-multiselect'
import vueCountryRegionSelect from 'vue-country-region-select'
import VueSimpleNotify from 'vue-simple-notify'
import Carousel3d from 'vue-carousel-3d'
import QuickEdit from 'vue-quick-edit'
import AOS from 'aos'
import VueMeta from 'vue-meta'
import VueMask from 'v-mask'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAddressCard, faClipboardList, faCogs, faCreditCard, faDolly, faMapMarkedAlt, faTachometerAlt, faTag, faTicketAlt, faUsers, faTruck, faUserTie, faEnvelope, faBars, faTimes, faTrash, faEdit, faSave, faCheck, faQrcode, faChartLine, faShoppingBasket, faDownload, faFileImage, faUser, faLock, faBoxOpen, faPlus, faSearch, faQuestion, faCommentMedical, faSignOutAlt, faShippingFast, faPhone, faUpload, faChevronLeft, faReceipt, faStore, faStar, faList } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import GoogleAuth from '@/config/google_oAuth.js'
import Notifications from 'vue-notification'
import VueGtag from "vue-gtag";
import VueMobileDetection from 'vue-mobile-detection'
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'nprogress/nprogress.css'
import "aos/dist/aos.css"
import 'primevue/resources/themes/saga-blue/theme.css' // theme
import 'primevue/resources/primevue.min.css' // core css
import 'primeicons/primeicons.css' // icons

const gauthOption = {
  clientId: '380587267167-khmtrq120g65s5ac4fsdn2o6nvpkm0oa.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GoogleAuth, gauthOption)

library.add(faAddressCard, faTicketAlt, faTachometerAlt, faCogs, faMapMarkedAlt, faUser, faUsers, faPhone, faTag, faCreditCard, faDolly, faClipboardList, faTruck, faPlus, faUserTie, faFacebookF, faLinkedinIn, faLock, faInstagram, faChartLine, faEnvelope, faBars, faTimes, faTrash, faEdit, faSave, faSearch, faCheck, faQrcode, faQuestion, faShoppingBasket, faDownload, faFileImage, faBoxOpen, faCommentMedical, faSignOutAlt, faShippingFast, faUpload, faChevronLeft, faReceipt, faStore, faTruck, faStar, faList )

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('frontUser-layout', FrontUser)
Vue.component('backClient-layout', BackClient)
Vue.component('frontHero-layout', FrontHero)
Vue.component('frontExperience-layout', FrontExperience)
Vue.component('backCleaner-layout', BackCleaner)
Vue.component('backSupport-layout', BackSupport)
Vue.component('backAdmin-layout', BackAdmin)
Vue.component('multiselect', Multiselect)
Vue.component('VueSimpleNotify', VueSimpleNotify.VueSimpleNotify)
Vue.component('quick-edit', QuickEdit)

Vue.filter('price', PriceFilter)
AOS.init();
Vue.use(Vuelidate)
Vue.use(VueCookies)
Vue.use(VueFeather)
Vue.use(SweetModal)
Vue.use(VueI18n)
Vue.use(vueCountryRegionSelect)
Vue.use(VueEllipseProgress)
Vue.use(Carousel3d)
Vue.use(Notifications)
Vue.use(VueMobileDetection)
Vue.use(VueGtag, {
  config: { id: 'G-F00H1E6C8V' }
});
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(VueMask)
Vue.use(PrimeVue)
Vue.use(ConfirmationService)

Vue.config.productionTip = false

export const i18n = new VueI18n({
  locale: localStorage.getItem('i18n-locale') || 'en',  //set locale
  fallbackLocale: 'en',
  messages,  //set locale message
});

//Auto-authentication//
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
//

const requireComponent = require.context(
  // The relative path of the components folder
  './components',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

new Vue({
  vuetify,
  router,
  store,
  i18n,
  created() {
    const userString = localStorage.getItem('user')
    const token = localStorage.getItem('token')
    if (userString) {
      const userData = JSON.parse(userString)
      userData.token = token
      this.$store.commit('SET_USER_DATA', userData)
    }
    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          this.$store.dispatch('logout')
        }
        return Promise.reject(error)
      }
    )
  },
  render: h => h(App)
}).$mount('#app')
